module.exports = __webpack_public_path__ + "img/male-youngchild-foot.e1b610e4.svg";